function toggleDescription(id) {
  var content = document.getElementById('DescriptionContent-' + id);
  var btn = document.getElementById('ReadMoreBtn-' + id);
  
  // The SVG icon provided by the user
  var svgIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none" class="akta-read-more-icon"><path d="M5.25003 4.81247C5.25003 4.92436 5.20726 5.03636 5.12184 5.12178L0.74684 9.49679C0.575887 9.66774 0.299059 9.66774 0.128215 9.49679C-0.0426289 9.32583 -0.0427383 9.049 0.128215 8.87816L4.1939 4.81247L0.128214 0.746785C-0.0427387 0.575832 -0.0427387 0.299004 0.128214 0.12816C0.299168 -0.0426846 0.575996 -0.0427933 0.746839 0.128159L5.12184 4.50316C5.20726 4.58858 5.25003 4.70058 5.25003 4.81247Z" fill="#6B6F5C"/></svg>';

  if (content.classList.contains('expanded')) {
    content.classList.remove('expanded');
    btn.classList.remove('expanded');
    btn.innerHTML = 'READ MORE ' + svgIcon;
  } else {
    content.classList.add('expanded');
    btn.classList.add('expanded');
    btn.innerHTML = 'READ LESS ' + svgIcon;
  }
}
